import graphqlRequest from "Services/assignment/assignmentRequest";
import UPDATE_MANIFEST, { UPDATE_MANIFEST_ITEMS } from "./graphql";

export async function updateManifest(input) {
  const response = await graphqlRequest(UPDATE_MANIFEST, {input});
  return response
}

export async function skipActivityInManifest(assignmentId,activityType,locale){
  let input = {assignmentId,activityType,locale,status: "DONE"};
  console.log("SKIPPING",input); //leave this in for troubleshooting.
  await updateManifest(input);
}

/**
 * Updates manifest items with story ID and activity type.
 * Retries up to 3 times if the call fails or throws for any reason.
 * 
 * @param {Array} updateManifestInput - Array of objects containing assignmentId, manifestId, and optionally storyId and activityType
 * @returns {Object} Response containing success and reject arrays
 */
export async function updateManifestItems(updateManifestInput) {
  const MAX_RETRIES = 3;
  let lastError;

  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const response = await graphqlRequest(UPDATE_MANIFEST_ITEMS, { updateManifestInput, timezone });
      
      // Check if there are any rejected items in the response
      if (response?.updateManifestItems?.reject?.length > 0) {
        const rejectedItems = response.updateManifestItems.reject;
        const errorMessage = `Request contained ${rejectedItems.length} rejected items: ${rejectedItems.map(r => r.reason.join(', ')).join('; ')}`;
        throw new Error(errorMessage);
      }
      
      return response;
    } catch (error) {
      lastError = error;
      console.warn(`updateManifestItems attempt ${attempt} failed:`, error.message);
      
      // If this is the last attempt, throw the error
      if (attempt === MAX_RETRIES) {
        throw lastError;
      }
      
      // Wait before retrying (exponential backoff)
      const delay = Math.pow(2, attempt - 1) * 1000; // 1s, 2s, 4s
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
}
